import { AtlasButtonProps, Button } from "@resource/atlas";
import { atlasLinkExternal } from "@resource/atlas/icons";
import { useLogEvent } from "analytics";
import clsx from "clsx";

interface PreviewGuideHeaderProps {
  variant?: AtlasButtonProps["variant"];
  previewUrl?: string;
}

function PreviewGuideHeader({ variant, previewUrl }: PreviewGuideHeaderProps) {
  const logEvent = useLogEvent({
    component: "PreviewGuideHeader",
    project: "Preview a guide as a candidate",
  });

  return (
    <div
      className="z-50 absolute top-0 left-0 pt-[1.375rem] px-6 flex justify-between items-center w-full"
      style={{
        background:
          variant === "light"
            ? "linear-gradient(180deg, rgba(0, 0, 0, 0.1) 20.83%, rgba(0, 0, 0, 0) 100%)"
            : "none",
      }}
    >
      <div
        className={clsx("grow text-body-md", {
          "text-white": variant === "light",
        })}
      >
        Previewing as <span className="font-semibold">candidate</span>
      </div>
      {previewUrl && (
        <Button
          onClick={() => {
            logEvent("Open Guide Preview Clicked");
            window.open(previewUrl, "_blank");
          }}
          icon={atlasLinkExternal}
          variant={variant}
        />
      )}
    </div>
  );
}

export default PreviewGuideHeader;
